/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Event_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Event tags updated successfully" |
*
* @param {Tags_Event_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_event_updated_toast = /** @type {((inputs?: Tags_Event_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Event_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Balises d'evenement mises a jour avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis-Tags erfolgreich aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tag evento aggiornati correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метки событий успешно обновлены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las etiquetas de eventos se actualizaron correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件标签已成功更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントタグが正常に更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टैग सफलतापूर्वक अपडेट हो गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Etiquetas do evento atualizadas com sucesso")
	return /** @type {LocalizedString} */ ("Event tags updated successfully")
});